import { render, staticRenderFns } from "./createCloudEventDia.vue?vue&type=template&id=624a85a4&scoped=true&"
import script from "./createCloudEventDia.vue?vue&type=script&lang=js&"
export * from "./createCloudEventDia.vue?vue&type=script&lang=js&"
import style0 from "./createCloudEventDia.vue?vue&type=style&index=0&id=624a85a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624a85a4",
  null
  
)

export default component.exports